export default "__VITE_ASSET__BAXXB5so__"